import { useState } from 'react';
import { ErroreRisposta, api } from '../api/client.ts';
import { requisitiMancanti } from './requisitiPassword.ts';
import stili from './Accesso.module.css';

/**
 * Cambio password obbligatorio al primo accesso.
 *
 * Gli account nascono con una password provvisoria, diversa per ogni persona,
 * che serve solo a entrare la prima volta. Finche' non la si cambia la sa
 * anche chi l'ha consegnata, e su un foglio puo' leggerla chiunque: nel
 * registro delle modifiche risulterebbe la persona sbagliata ad aver
 * inserito una richiesta.
 *
 * Per questo la schermata non e' saltabile: non c'e' un "lo faro' dopo".
 */
export function CambioPassword({
  nomeUtente,
  onCambiata,
}: {
  nomeUtente: string;
  onCambiata: () => void;
}) {
  const [nuova, setNuova] = useState('');
  const [conferma, setConferma] = useState('');
  const [errore, setErrore] = useState<string | null>(null);
  const [inCorso, setInCorso] = useState(false);

  const mancanti = requisitiMancanti(nuova);
  const diverse = conferma.length > 0 && nuova !== conferma;
  const valida = mancanti.length === 0 && nuova === conferma;

  async function invia(evento: React.FormEvent) {
    evento.preventDefault();
    setErrore(null);
    setInCorso(true);
    try {
      await api.cambiaPassword(nuova);
      onCambiata();
    } catch (e) {
      setErrore(e instanceof ErroreRisposta ? e.message : 'Cambio non riuscito.');
    } finally {
      setInCorso(false);
    }
  }

  return (
    <div className={stili.pagina}>
      <form className={stili.riquadro} onSubmit={invia}>
        <h1 className={stili.titolo}>Scegli una password</h1>
        <p className={stili.sottotitolo}>
          {nomeUtente}, la password provvisoria che ti hanno consegnato va cambiata
          prima di continuare. Servono almeno 8 caratteri, con una maiuscola, una
          minuscola, un numero e un carattere speciale.
        </p>

        <label className={stili.campo}>
          <span className={stili.etichetta}>Nuova password</span>
          <input
            className={stili.input}
            type="password"
            value={nuova}
            onChange={(e) => setNuova(e.target.value)}
            autoComplete="new-password"
            autoFocus
          />
        </label>

        <label className={stili.campo}>
          <span className={stili.etichetta}>Ripeti la password</span>
          <input
            className={stili.input}
            type="password"
            value={conferma}
            onChange={(e) => setConferma(e.target.value)}
            autoComplete="new-password"
          />
        </label>

        {nuova.length > 0 && mancanti.length > 0 && (
          <p className={stili.errore}>Manca: {mancanti.join(', ')}.</p>
        )}
        {diverse && <p className={stili.errore}>Le due password non coincidono.</p>}
        {errore && <p className={stili.errore}>{errore}</p>}

        <button type="submit" className={stili.pulsante} disabled={!valida || inCorso}>
          {inCorso ? 'Salvataggio…' : 'Salva e continua'}
        </button>
      </form>
    </div>
  );
}
